if (!customElements.get('product-videos')) {
  customElements.define(
    'product-videos',
    class ProductVideos extends HTMLElement {
      constructor() {
        super();
        this.onThumbnailClick = this.onThumbnailClick.bind(this);
      }

      // connected/disconnected run on theme editor section load/unload, so listeners never stack
      connectedCallback() {
        this.addEventListener('click', this.onThumbnailClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onThumbnailClick);
      }

      onThumbnailClick(event) {
        const thumbnail = event.target.closest('.product-videos__thumbnail');
        if (!thumbnail || thumbnail.getAttribute('aria-current') === 'true') return;

        const index = thumbnail.dataset.videoIndex;

        this.querySelectorAll('.product-videos__player').forEach((player) => {
          const isActive = player.dataset.videoIndex === index;
          if (!isActive) player.querySelector('video')?.pause();
          player.hidden = !isActive;
        });

        this.querySelectorAll('.product-videos__thumbnail').forEach((button) => {
          if (button === thumbnail) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
  );
}
